module.exports = __webpack_public_path__ + "static/media/project14.ff35e233.png";